export default {
  SEARCH_STEP_NEW_CLIENT_WAS_ADDED_QUERY: Symbol.for('SEARCH_STEP_NEW_CLIENT_WAS_ADDED_QUERY'),
  CREATE_USER_PASSWORD_VERIFY_TOKEN_QUERY: Symbol.for('CREATE_USER_PASSWORD_VERIFY_TOKEN_QUERY'),
  REQUEST_NEW_LINK_TO_REGISTER_COMMAND: Symbol.for('REQUEST_NEW_LINK_TO_REGISTER_COMMAND'),
  ON_BOARDING_STEPS_REPOSITORY: Symbol.for('ON_BOARDING_STEPS_REPOSITORY'),
};
